import React, { Component } from 'react'
import { Dispatch } from 'react-redux'
import * as validation from '~/helper/constant/validation'
import { editSmsPackage, getSmsPackage } from '~/services/api'
import { SmsPackageDTO } from '~/model'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import * as modules from '~/helper/constant/modules'
import * as route from '~/helper/constant/route'
import { toastMessage, getCurrency, getSms, getCountryList } from '~/helper/function/util'
import { redirect } from '~/helper/function/util'

type Props = {
    token: String,
    dispatch: Dispatch<any>,
}

type State = {
    name: String,
    code: String,
    limit: String,
    type: String,
    defaultType: String,
    currency: String,
    defaultCurrency: String,
    country: Array,
    defaultCountry: Object,
    errors: Object,
    smsPackages: Object,
    loading: Boolean,
    loading_text: String,
}

export class AbstractSmsPackageEditComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: false,
            loading_text: 'Loading',
            name: '',
            code: '',
            limit: 0,
            type: 0,
            currency: '',
            rate: 0,
            country: [],
            errors: {
                name: null,
                code: null,
                limit: null,
                type: null,
                country: null,
                currency: null,
                rate: null,
            },
        }
        this._handleChange = this._handleChange.bind(this)
        this._onSave = this._onSave.bind(this)
    }

    componentDidMount() {
        this.getData()
    }

    getData() {
        this._handleChange('loading_text', 'Loading')
        this._handleChange('loading', true)
        getSmsPackage(this.props.match.params.id, this.props.token).then((response) => {
            this._handleChange('loading', false)
            if (response.code == API_SUCCESS) {
                const smsPackages: SmsPackageDTO = response.data.sms_package
                this.setState({
                    id: smsPackages.id,
                    name: smsPackages.name,
                    code: smsPackages.code,
                    limit: parseFloat(smsPackages.limit),
                    type: smsPackages.type,
                    country: smsPackages.country,
                    rate: parseFloat(smsPackages.rate),
                    currency: smsPackages.currency,
                    defaultCurrency: getCurrency(smsPackages.currency),
                    defaultType: getSms(smsPackages.type),
                    defaultCountry: getCountryList(smsPackages.country),
                    smsPackages,
                })
            }
        })
    }

    _handleChange(key, data) {
        this.setState({ [key]: data })
    }

    _onSave(e) {
        e.preventDefault()
        const errors = validation.required(Object.keys(this.state.errors), this.state)
        this.setState({ errors })
        const validate = Object.keys(errors).filter((item) => errors[item] != null)
        if (validate.length == 0) {
            const data: SmsPackageDTO = {
                name: this.state.name,
                code: this.state.code,
                limit: this.state.limit,
                type: this.state.type,
                country: this.state.country,
                currency: this.state.currency,
                rate: this.state.rate,
            }
            this._handleChange('loading_text', 'Saving')
            this._handleChange('loading', true)
            editSmsPackage(this.props.match.params.id, data, this.props.token).then((response) => {
                this._handleChange('loading', false)
                if (response.code == API_SUCCESS) {
                    toastMessage('success', response.message)
                    redirect(route.superadmin.sms_package.view, this.props.history)
                } else {
                    toastMessage('error', response.message)
                    if (response.data) {
                        if ('errors' in response.data) {
                            this.setState({ errors: response.data.errors })
                        }
                    }
                }
            })
        }
    }
}

export function mapStateToProps(state: Object) {
    return {
        token: state.token,
    }
}
